import { CustomTooltip } from '@/components/custom-tooltip';
import type { TooltipProps } from '@mui/material';

import type React from 'react';

interface ComingSoonTooltipProps extends Omit<TooltipProps, 'title'> {
	children: React.ReactElement;
}

const ComingSoonTooltip: React.FC<ComingSoonTooltipProps> = ({ children }) => (
	<CustomTooltip content={<p>{'Coming Soon'}</p>} placement='right'>
		{children}
	</CustomTooltip>
);

export default ComingSoonTooltip;
